import {coreApi} from '~/services/core'

export const importerService = {
  getAll: async () => coreApi.get(`importer`),
  getById: async (id) => coreApi.get(`importer?id=${id}`),
  create: async (data) => coreApi.post(`importer`, data),
  update: async (data) => coreApi.put(`importer`, data),
  paginate: async (offset) => coreApi.get(`importer/${offset}`)
}